"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.RowTableMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _reactRouterDom = require("react-router-dom");
var _Link = require("react-platform-components/dist/Link/Link");
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../../../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuItem: {
      position: "relative"
    },
    menuItemLink: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    },
    menuItemIcon: {
      minWidth: "44px"
    },
    deleteMenuItem: {
      whiteSpace: "nowrap",
      "&, & .MuiListItemIcon-root": {
        // color: "rgb(255, 72, 66)",
        color: theme.palette.error.light
      }
    }
  };
});
exports.useStyles = useStyles;
var RowTableMenu = (0, _Translations.injectIntl)(function (props) {
  var classes = useStyles();
  var product = props.product,
    MenuItemsComponent = props.menuItemsComponent,
    openEdit = props.openEdit,
    detailEndpoint = props.detailEndpoint,
    openConfirmDialog = props.openConfirmDialog,
    showReviews = props.showReviews,
    handleProductReviewsList = props.handleProductReviewsList,
    anchorEl = props.anchorEl,
    open = props.open,
    handleClose = props.handleClose;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Menu, {
    id: "simple-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: open,
    onClose: handleClose
  }, MenuItemsComponent ? /*#__PURE__*/_react.default.createElement(MenuItemsComponent, _extends({}, props, {
    handleProductReviewsList: handleProductReviewsList
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.menuItem
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
    classes: {
      root: classes.menuItemIcon
    },
    onClick: _config.PRODUCTS_CREATION_TYPE === "dialog" ? openEdit(product) : undefined
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "edit")), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: props.intl.formatMessage({
      id: "Product_edit",
      defaultMessage: "Product_edit"
    })
  }), _config.PRODUCTS_CREATION_TYPE !== "dialog" && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: classes.menuItemLink,
    to: "/".concat(_config.PRODUCTS_CREATION_ENDPOINT, "/").concat(product.id)
  })), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.menuItem
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
    classes: {
      root: classes.menuItemIcon
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "remove_red_eye")), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: props.intl.formatMessage({
      id: "Product_view",
      defaultMessage: "Product_view"
    })
  }), _config.REACT_PRODUCT_DETAIL_ENDPOINT ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: classes.menuItemLink,
    to: "/".concat(detailEndpoint, "/").concat(product.id)
  }) : /*#__PURE__*/_react.default.createElement(_Link.Link, {
    className: classes.menuItemLink,
    to: "".concat(_config.PRODUCT_DETAIL_ENDPOINT, "/").concat(product.id),
    base: _config.BASE_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  })), showReviews && /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    onClick: handleProductReviewsList,
    className: classes.menuItem
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
    classes: {
      root: classes.menuItemIcon
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "star_rate")), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: props.intl.formatMessage({
      id: "Product_reviews",
      defaultMessage: "Product_reviews"
    })
  })), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    variant: "fullWidth"
  }), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    onClick: openConfirmDialog(product),
    className: classes.deleteMenuItem
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
    classes: {
      root: classes.menuItemIcon
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "delete")), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: props.intl.formatMessage({
      id: "Product_delete",
      defaultMessage: "Product_delete"
    })
  })))));
});
exports.RowTableMenu = RowTableMenu;